import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, input, signal } from '@angular/core';
import { EntityStatus } from '@core';

import { formatUptimeDuration } from '../../helpers';
import type { DeviceData } from '../../models/devices';

const REFRESH_INTERVAL_MS = 60 * 1000;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'avs-device-uptime-legend',
  template: '{{ duration() }}',
})
export class DeviceUptimeLegendComponent {
  device = input.required<DeviceData>();

  protected duration = computed(() => {
    const { latestUptimeStatusChangeTimestamp, status, uptimeStatus } = this.device();

    this.refreshTick();

    if (!uptimeStatus || !latestUptimeStatusChangeTimestamp || status === EntityStatus.Archived) {
      return '';
    }

    return formatUptimeDuration(Date.now() - new Date(latestUptimeStatusChangeTimestamp).getTime());
  });

  private refreshTick = signal(0);

  constructor() {
    const interval = setInterval(() => this.refreshTick.update(tick => tick + 1), REFRESH_INTERVAL_MS);

    inject(DestroyRef).onDestroy(() => clearInterval(interval));
  }
}
